import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

export default function LastName({ id, label, onChange, value }) {
  function handleChange(event) {
    let inputElement = document.getElementById(event.target.id);
    let errorElement = inputElement.nextSibling;
    if (event.target.value.trim().length === 0) {
      inputElement.classList.add('is-invalid');
      errorElement.innerHTML = "The Last name can't be empty";
      errorElement.style.display = 'block';
    } else if (!/^[ a-zA-Z\\&-]+$/.test(event.target.value)) {
      inputElement.classList.add('is-invalid');
      errorElement.innerHTML =
        'The Last name should contain only letters and & \\ - symbols';
      errorElement.style.display = 'block';
    } else if (event.target.value.toString().toLowerCase().includes('null')) {
      inputElement.classList.add('is-invalid');
      errorElement.innerHTML = 'The Last name can\'t contain "Null" name.';
      errorElement.style.display = 'block';
    } else {
      errorElement.style.display = 'none';
      inputElement.classList.remove('is-invalid');
    }
    onChange(event, id);
  }

  return (
    <>
      <Form.Group as={Row} className="mb-3" controlId={id}>
        <Form.Label column sm={6} required>
          {label}
        </Form.Label>

        <Form.Control
          type="text"
          required
          placeholder={label}
          pattern="^[A-Za-z&\-\\ ]+$"
          maxLength="30"
          onKeyPress={(event) => {
            if (!/[ a-zA-Z&\\-]/.test(event.key)) event.preventDefault();
          }}
          onChange={handleChange}
          data-hj-allow
          value={value ? value : ''}
        />
        <Form.Control.Feedback type="invalid">
          Please provide a valid name
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
}
